import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 5vh;

  @media only screen and (min-width: 769px) {
    width: 1061px;
    max-width: 100%;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 32px;

  @media only screen and (min-width: 769px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 40px;
    margin-top: 40px;
  }
`;

// Sponsor card (Figma node 9048:1366, 327×254): white key-visual box on a
// light-lavender base with a "Kunjungi Halaman Situs" footer link.
export const Card = styled.div`
  width: 100%;
  max-width: 327px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
  border-radius: 24px;
  background: #eaebf1;
  cursor: pointer;

  @media only screen and (min-width: 769px) {
    width: 327px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 206px;
  border-radius: 24px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 24px;
  color: #1f2d3d;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
`;
